import React, { useCallback, useEffect, useState } from 'react';
import { ICrumbs } from 'src/components/profileComponents/Breadcrumbs';
import { translations } from 'src/constants/translations';
import { pathList } from 'src/containers/Profile/routeList';
import { UsersPageWrapper } from 'src/components/profileComponents/Users/components/UsersPageWrapper';
import { useParams } from 'react-router-dom';
import { useDebounce, useGetComplex } from 'src/hooks';
import Box from '@mui/material/Box';
import { Loader } from 'src/components/Loader';
import { ButtonApp } from 'src/components/Button';
import { UserInput } from 'src/components/profileComponents/Users/components/UserInput';
import InputAdornment from '@mui/material/InputAdornment';
import { appIcon } from 'src/assets';
import { ComplexStatus } from 'src/components/profileComponents/ComplexStatus';
import { ComplexStatuses } from 'src/components/profileComponents/EditComplex/components/ComplexStatuses';
import { useGlobalGrid } from 'src/hooks/app/use-global-grid';
import { SvgLink } from 'src/components/ApartmentPageV2/LayoutApartmentItem/components/SvgLink';
import { SvgPlanet } from 'src/components/ApartmentPageV2/LayoutApartmentItem/components/SvgPlanet';
import AddIcon from '@mui/icons-material/Add';
import { AppInputSearch } from 'src/components/AppInputSearch';
import { useStyles as useEditComplexStyles } from '../../styles';
import { useStyles } from './styles';

export const ComplexStatusesPage: React.FC = () => {
  const { id }: { id: string } = useParams();
  const { complex, fetchComplex } = useGetComplex(id);
  const [addStatusTrigger, setAddStatusTrigger] = useState<boolean>(false);
  const [debouncedSearch, setDebouncedSearch] = useState<string>('');
  const { getGridsWidth } = useGlobalGrid();
  const styles = useStyles(getGridsWidth);
  const editComplexStyles = useEditComplexStyles(getGridsWidth);

  useEffect(() => {
    fetchComplex();
  }, []);

  const setDebouncedSearchValue = useCallback((value: string) => {
    setDebouncedSearch(value);
  }, [setDebouncedSearch]);

  if (!complex) {
    return (
      <Box
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Loader />
      </Box>
    );
  }

  const crumbs: ICrumbs[] = [
    {
      name: translations.complexesLink,
      url: `/profile/${pathList.complexes}`,
    },
    {
      name: `${translations.settings} ${complex?.title[complex?.language]}`,
      url: `/profile/${pathList.complexes}/${id}`,
    },
    {
      name: translations.manageStatuses,
    },
  ];

  return (
    <UsersPageWrapper
      crumbs={crumbs}
      title={(
        <Box display="flex" justifyContent="space-between">
          <>
            <Box display="flex" gap="10px" alignItems="center">
              MANAGE STATUSES AT
              {' '}
              <span>{complex?.title[complex?.language] || ''}</span>
              <ComplexStatus complexStatus={complex.status} />
            </Box>
            <ButtonApp
              startIcon={<AddIcon />}
              text={translations.addStatus}
              color="primary"
              variant="contained"
              className={editComplexStyles.btn}
              onClick={() => setAddStatusTrigger(true)}
            />
          </>
        </Box>
      )}
    >
      <div>
        <div className={styles.wrapper}>
          <AppInputSearch
            placeholder={translations.statusSearchPlaceholder}
            onDebouncedSearch={setDebouncedSearchValue}
          />
          <div className={styles.notice}>
            <div className="item">
              <SvgPlanet />
              <span>Show on website controls public visibility</span>
            </div>
            <div className="item">
              <SvgLink />
              <span>Attachable to deal makes the status usable in CRM</span>
            </div>
          </div>
        </div>
        <ComplexStatuses
          complex={complex}
          addStatusTrigger={addStatusTrigger}
          close={setAddStatusTrigger}
          search={debouncedSearch}
        />
      </div>
    </UsersPageWrapper>
  );
};
